import React from "react";
import DatasetBuilder from "./dataset_builder/DatasetBuilder";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

const DatasetBuilderApp = () => {
  const navigate = useNavigate();
  return (
      <div className="dashboardPage">
        <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '1rem' }}>
            <Button variant="contained" color="primary" onClick={() => navigate("/AMU")}>
                Go to Dashboard
            </Button>
        </div>
        <DatasetBuilder />
      </div>
  );
};

export default DatasetBuilderApp;